import {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import {useAuth} from '../context/authContext';
import Footer from '../module/auth/footer';

const AuthLayout = () => {
  const {supplierProfile} = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (supplierProfile) {
      navigate('/home');
    }
  }, [supplierProfile, navigate]);
  return (
    <>
      <div className="flex w-full h-full flex-col justify-between">
        {/* <motion.div
          key={pathname}
          initial={{opacity: 0, x: '100%'}}
          animate={{opacity: 1, x: 0}}
          exit={{opacity: 0, x: '-100%'}}
          transition={{duration: 0.2}}
          className="w-100 h-100"
        > */}
        <div></div>
        <div className="d-flex w-full flex-col justify-center">
          <Outlet />
        </div>
        {/* </motion.div> */}
        <div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
